export class ValoresPorSabor {
    public tamanho: string = '';
    public precoVendaInicial: number = 0;
    public precoVendaPromocionalInicial: number = 0;
    public precoVenda: number = 0;
    public precoVendaPromocional: number = 0;
    public sabor: string = '';
    public tipoProduto: 'PIZZA' | 'LASANHA' = 'PIZZA';
    public codigoProduto: number = 0;
    public ativo: boolean = false; //status da celula ou input do grid
    public usarPrecoPromocionalInicial: boolean = false;
    public usarPrecoPromocional: boolean = false;

    public get nomeProduto() : string {
        return `${this.tipoProduto} ${this.tamanho} ${this.sabor}`;
    }    
}
